export default "__VITE_ASSET__CLkn6XwX__"